<template>
  <div class="quiz-card">
    <!-- 顶部标题栏 -->
    <div class="quiz-header">
      <div class="quiz-status">
        <img
          :src="cdnUrl + 'ai-thank-icon.svg'"
          class="quiz-status-icon"
          alt="等待澄清"
        />
        <span class="quiz-status-text">等待澄清</span>
      </div>
      <div class="quiz-progress">
        <div
          @click="prevQuestion"
          class="quiz-progress-btn"
          :class="{ 'quiz-progress-btn_disabled': currentIndex === 0 }"
        >
          <img
            :src="
              cdnUrl +
              (currentIndex === 0
                ? 'ai-icon-arrow-left-disabled.svg'
                : 'ai-icon-arrow-left.svg')
            "
            alt="上一题"
            class="quiz-progress-btn-icon quiz-progress-btn-icon_default"
          />
          <img
            :src="cdnUrl + 'ai-icon-arrow-left-hover.svg'"
            alt="上一题"
            class="quiz-progress-btn-icon quiz-progress-btn-icon_hover"
          />
        </div>
        <span class="quiz-progress-text"
          >{{ currentIndex + 1 }}/{{ questions.length }}</span
        >
        <div
          @click="nextQuestion"
          class="quiz-progress-btn"
          :class="{
            'quiz-progress-btn_disabled': currentIndex === questions.length - 1,
          }"
        >
          <img
            :src="
              cdnUrl +
              (currentIndex === questions.length - 1
                ? 'ai-icon-arrow-right-disabled.svg'
                : 'ai-icon-arrow-right.svg')
            "
            alt="下一题"
            class="quiz-progress-btn-icon quiz-progress-btn-icon_default"
          />
          <img
            :src="cdnUrl + 'ai-icon-arrow-right-hover.svg'"
            alt="下一题"
            class="quiz-progress-btn-icon quiz-progress-btn-icon_hover"
          />
        </div>
      </div>
    </div>

    <!-- 问题区域 -->
    <div class="quiz-content">
      <div class="quiz-question">
        <span>{{ currentIndex + 1 }}.{{ currentQuestion.title }}</span>
      </div>

      <!-- 单选类型 -->
      <div
        v-if="currentQuestion.inputType === 'single_select'"
        class="quiz-options"
      >
        <el-radio-group v-model="selectedAnswer">
          <el-radio
            v-for="(option, optIndex) in currentQuestion.options"
            :key="optIndex"
            :label="optIndex"
            class="quiz-option"
            :class="{
              'quiz-option-selected': selectedAnswer === optIndex,
              'quiz-option-other': isOtherOption(option),
            }"
          >
            <span class="quiz-option-text">{{ option.label }}</span>
            <!-- 其他选项的文本输入框 -->
            <div
              v-if="
                isOtherOption(option) &&
                selectedAnswer === optIndex &&
                otherInputVisible
              "
              class="quiz-other-input-wrap"
            >
              <input
                v-model="otherInputValue"
                type="text"
                class="quiz-other-input"
                :placeholder="option.placeholder || '请输入...'"
              />
            </div>
          </el-radio>
        </el-radio-group>
      </div>

      <!-- 日期选择类型 -->
      <div
        v-else-if="currentQuestion.inputType === 'datetime_picker'"
        class="quiz-options"
      >
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="~"
          :start-placeholder="'开始时间'"
          :end-placeholder="'结束时间'"
          class="quiz-date-picker"
        />
      </div>

      <!-- 底部按钮 -->
      <div class="quiz-footer">
        <div class="quiz-btn quiz-btn-skip" @click="handleSkip">跳过并继续</div>
        <div
          class="quiz-btn quiz-btn-primary"
          :class="{ 'quiz-btn-disabled': !canContinue }"
          @click="handleContinue"
        >
          {{ isLastQuestion ? "完成并继续" : "继续" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "quizCard",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      cdnUrl: "https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/",
      currentIndex: 0,
      selectedAnswer: null,
      answers: [],
      otherInputValue: "",
      otherInputVisible: true,
      dateRange: [],
    };
  },
  computed: {
    questions() {
      return (this.item.packs || []).filter((q) => !q.answered);
    },
    currentQuestion() {
      return this.questions[this.currentIndex] || {};
    },
    isLastQuestion() {
      return this.currentIndex === this.questions.length - 1;
    },
    isOtherSelected() {
      if (this.selectedAnswer === null) return false;
      const option = this.currentQuestion.options[this.selectedAnswer];
      return this.isOtherOption(option);
    },
    canContinue() {
      if (this.currentQuestion.inputType === "datetime_picker") {
        return this.dateRange && this.dateRange.length === 2;
      }
      if (this.selectedAnswer === null) return false;
      if (this.isOtherSelected && !this.otherInputValue.trim()) return false;
      return true;
    },
  },
  watch: {
    item: {
      immediate: true,
      handler(val) {
        if (val.scenarioType) {
          this.currentIndex = 0;
          this.selectedAnswer = null;
          this.answers = [];
          this.otherInputValue = "";
        }
      },
    },
    currentIndex(newIndex, oldIndex) {
      if (oldIndex !== undefined) {
        if (this.questions[oldIndex].inputType === "datetime_picker") {
          this.answers[oldIndex] = {
            dateRange: [...this.dateRange],
          };
        } else {
          this.answers[oldIndex] = {
            index: this.selectedAnswer,
            otherValue: this.otherInputValue,
          };
        }
      }
      const savedAnswer = this.answers[newIndex];
      if (savedAnswer !== undefined) {
        if (this.questions[newIndex].inputType === "datetime_picker") {
          this.dateRange = savedAnswer.dateRange || [];
        } else {
          this.selectedAnswer = savedAnswer.index;
          this.otherInputValue =
            savedAnswer.otherText || savedAnswer.otherValue || "";
        }
      } else {
        if (this.questions[newIndex].inputType === "datetime_picker") {
          this.dateRange = [];
        } else {
          this.selectedAnswer = null;
          this.otherInputValue = "";
        }
      }
    },
  },
  methods: {
    isOtherOption(option) {
      return (
        option &&
        (option.needInput ||
          option.value === "other" ||
          option.value === "other")
      );
    },
    handleContinue() {
      if (!this.canContinue) return;
      let answerData;

      if (this.currentQuestion.inputType === "datetime_picker") {
        const startDate = this.formatDate(this.dateRange[0]);
        const endDate = this.formatDate(this.dateRange[1]);
        answerData = {
          questionId: this.currentQuestion.questionId,
          value: `${startDate}至${endDate}`,
          dateRange: [...this.dateRange],
        };
      } else {
        const currentOption = this.currentQuestion.options[this.selectedAnswer];
        answerData = {
          questionId: this.currentQuestion.questionId,
          value: currentOption.value,
          ...(this.isOtherSelected && {
            otherText: this.otherInputValue.trim(),
          }),
          _original: {
            index: this.selectedAnswer,
            label: currentOption.label,
            title: this.currentQuestion.title,
          },
        };
      }

      this.answers[this.currentIndex] = answerData;

      if (this.isLastQuestion) {
        this.$emit("continue", this.formatAnswers());
      } else {
        this.currentIndex++;
      }
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatAnswers() {
      const formatted = [];
      const originalQuestions = this.item.packs || [];
      let currentAnswerIndex = 0;

      originalQuestions.forEach((q) => {
        if (q.answered && q.displayValue) {
          formatted.push({
            questionId: q.questionId,
            value: q.displayValue,
            title: q.title,
            answered: q.answered,
          });
        } else {
          const answer = this.answers[currentAnswerIndex];
          if (answer) {
            if (answer.skipped) {
              formatted.push({
                questionId: q.questionId,
                skipped: true,
                title: q.title,
              });
            } else if (
              q.inputType === "datetime_picker" &&
              answer.dateRange &&
              answer.dateRange.length === 2
            ) {
              const startDate = this.formatDate(answer.dateRange[0]);
              const endDate = this.formatDate(answer.dateRange[1]);
              formatted.push({
                questionId: q.questionId,
                value: `${startDate}至${endDate}`,
                title: q.title,
              });
            } else if (answer.index !== null && answer.index !== undefined) {
              const option = q.options[answer.index];
              if (option) {
                const result = {
                  questionId: q.questionId,
                  value: option.value,
                  title: q.title,
                };
                if (answer.otherText) {
                  result.otherText = answer.otherText;
                } else if (answer.otherValue && this.isOtherOption(option)) {
                  result.otherText = answer.otherValue;
                }
                formatted.push(result);
              } else {
                formatted.push({
                  questionId: q.questionId,
                  skipped: true,
                  title: q.title,
                });
              }
            } else if (answer.value) {
              const result = {
                questionId: q.questionId,
                value: answer.value,
                title: q.title,
              };
              if (answer.otherText) {
                result.otherText = answer.otherText;
              }
              formatted.push(result);
            } else {
              formatted.push({
                questionId: q.questionId,
                skipped: true,
                title: q.title,
              });
            }
          } else {
            formatted.push({
              questionId: q.questionId,
              skipped: true,
              title: q.title,
            });
          }
          currentAnswerIndex++;
        }
      });

      return {
        formSubmit: true,
        formAnswers: {
          formType: "smart_crowd",
          answers: formatted,
        },
      };
    },
    handleSkip() {
      this.answers[this.currentIndex] = { skipped: true };
      this.selectedAnswer = null;
      this.otherInputValue = "";
      if (this.isLastQuestion) {
        this.$emit("continue", this.formatAnswers());
      } else {
        this.currentIndex++;
      }
    },
    nextQuestion() {
      if (this.currentIndex < this.questions.length - 1) {
        this.currentIndex++;
      }
    },
    prevQuestion() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.quiz-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e9e9e9;
  overflow: hidden;
  margin-top: 16px;
  margin-bottom: 8px;
}

.quiz-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 12px 16px 16px;
  background-color: #f3f5f7;
}

.quiz-status {
  display: flex;
  align-items: center;
  gap: 4px;
}

.quiz-status-icon {
  width: 20px;
  height: 20px;
}

.quiz-status-text {
  font-size: 14px;
  color: #999999;
}

.quiz-progress {
  display: flex;
  align-items: center;
}

.quiz-progress-text {
  font-size: 14px;
  color: #8f959e;
}

.quiz-progress-btn {
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: all 0.2s;
  padding: 2px;
  border-radius: 4px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(.quiz-progress-btn_disabled) {
    .quiz-progress-btn-icon_default {
      opacity: 0;
    }

    .quiz-progress-btn-icon_hover {
      opacity: 1;
    }
  }

  &_disabled {
    cursor: not-allowed;
    opacity: 0.5;

    .quiz-progress-btn-icon_hover {
      opacity: 0;
    }
  }
}

.quiz-progress-btn-icon {
  width: 20px;
  height: 20px;
  position: absolute;
  transition: opacity 0.2s;

  &_default {
    opacity: 1;
  }

  &_hover {
    opacity: 0;
  }
}

.quiz-content {
  padding: 16px;
}

.quiz-question {
  flex: 1;
  color: #4c4c4c;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 16px;
}

.quiz-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.quiz-date-picker {
  width: 100% !important;
}

.quiz-option {
  display: flex;
  align-items: center;
  padding: 9px 16px;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid #e5e9f2;
  margin-bottom: 8px;
  margin-right: 0px;
  &:last-child {
    margin-bottom: 0px;
  }

  &:hover {
    border-color: #3159ff;
    background: rgba(49, 89, 255, 0.08);
    ::v-deep {
      .el-radio__inner {
        border-color: #3159ff;
      }
    }
  }

  &-selected {
    background: rgba(49, 89, 255, 0.08);
    border-color: #3159ff;
  }
  ::v-deep {
    .el-radio__label {
      flex: 1;
    }
    .el-radio__input {
      width: 14px;
      height: 14px;
    }
  }
}

.quiz-option-text {
  flex: 1;
  font-size: 12px;
  color: #666666;
}

.quiz-option-other {
  align-items: flex-start;
}

.quiz-other-input-wrap {
  padding-left: 0;
  margin-top: 10px;
  margin-left: -24px;
}

.quiz-other-input {
  width: 100%;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #e5e6eb;
  border-radius: 6px;
  font-size: 14px;
  color: #1d2129;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #3159ff;
  }

  &::placeholder {
    color: #bfbfbf;
    font-size: 12px;
  }
}

.quiz-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

.quiz-btn {
  line-height: 30px;
  height: 30px;
  padding: 0px 12px;
  border-radius: 20px;
  font-size: 12px;
  cursor: pointer;

  &-skip {
    color: #333333;
    border: 1px solid #d9d9d9;
  }

  &-primary {
    background: #3159ff;
    color: #fff;
  }

  &-disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
